var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        height: "17",
        viewBox: "0 0 17 17",
        width: "17",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("g", { attrs: { fill: "#48B6E7", "fill-rule": "nonzero" } }, [
        _c("circle", { attrs: { cx: "8.854", cy: "11.997", r: "1" } }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M16.15.31H.85a.856.856 0 0 0-.85.857v12.005a.856.856 0 0 0 .85.857h5.1v1.14a.814.814 0 0 1-.85.86H3.4a.285.285 0 0 0-.283.287c0 .158.127.286.283.286h10.2a.285.285 0 0 0 .283-.286.285.285 0 0 0-.283-.286h-1.7a.812.812 0 0 1-.85-.858V14.03h5.1a.856.856 0 0 0 .85-.857V1.167a.856.856 0 0 0-.85-.857zM3.885 1.536a.29.29 0 0 1 0 .406l-1.7 1.715a.286.286 0 0 1-.403 0 .29.29 0 0 1 0-.406l1.7-1.715a.284.284 0 0 1 .402 0zm-2.67.572l.567-.572a.283.283 0 0 1 .402.002c.11.112.11.292 0 .404l-.566.572a.286.286 0 0 1-.403 0 .29.29 0 0 1 0-.406zM7.569 15.09a.297.297 0 0 1-.258.077.178.178 0 0 1-.051-.017.214.214 0 0 1-.051-.026l-.043-.034a.295.295 0 0 1-.059-.095.272.272 0 0 1 0-.217.33.33 0 0 1 .06-.094.293.293 0 0 1 .402 0c.11.112.11.293 0 .406zm1.133 0a.286.286 0 0 1-.402 0 .33.33 0 0 1-.06-.095.287.287 0 0 1-.022-.108.302.302 0 0 1 .082-.203.293.293 0 0 1 .402 0c.11.112.11.293 0 .406zM8.5 12.886a.996.996 0 0 1-.992-1c0-.553.444-1 .992-1s.992.447.992 1c0 .552-.445 1-.992 1zm1.394 2.11a.33.33 0 0 1-.06.094.283.283 0 0 1-.402-.003.289.289 0 0 1 0-.403.291.291 0 0 1 .402 0 .33.33 0 0 1 .06.094c.03.07.03.148 0 .217zm6.54-4.682H.566v-.572h15.866v.572z",
          },
        }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }